import {currencyFormatter} from "../../../../utilities/number-utilities";
import GENERAL_TRANSLATIONS from '../../../../translations/translations@default.json';

const FormatterV1 = currencyFormatter(GENERAL_TRANSLATIONS.general);

export default FormatterV1;